export default {"src":"/_next/static/media/Chiari Malformations.893fc039.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};